import { InvoiceOut } from '../../store/api';
import { shopPrefix } from '../../config';
import fileDownload from 'react-file-download';
import { http } from '../axios';
import axios from 'axios';

const GET_INVOICE_URL_ENDPOINT = `${shopPrefix}/v1/invoices/:invoiceId/url`;

export async function downloadInvoice(invoice: InvoiceOut): Promise<void> {
    return http
        .get(GET_INVOICE_URL_ENDPOINT, { pathParams: { invoiceId: invoice.invoiceId } })
        .then(response => axios.get(response.data.url, { responseType: 'arraybuffer' }))
        .then(response => {
            fileDownload(response.data, `${invoice.invoiceNumber}.pdf`);
        });
}
